import * as React from 'react'
import tw from 'tailwind-styled-components'

import { useFormAppearance } from '@/hooks/useFormAppearance'
import cn from '@/utils/tailwind/cn'

type RadioProps = {
  checked: boolean
  disabled: boolean
  hasError?: boolean
  inputId: string
  label: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  willShowNotAllowedCursor: boolean
}

type StyledRadioProps = {
  $willShowNotAllowedCursor?: boolean
  $hasError?: boolean
}

const StyledRadio = tw.input<StyledRadioProps>`
  form-radio
  border
  h-5
  text-blue-600
  w-5

  ${(props: { $willShowNotAllowedCursor?: boolean }) => {
    if (props.$willShowNotAllowedCursor) return 'cursor-not-allowed bg-gray-100'

    return 'cursor-pointer'
  }}

  ${(props: { $hasError?: boolean }) => {
    if (props.$hasError) return 'border-red-500 border-2'

    return ''
  }}
`

const StyledLabel = tw.div`
  inline-block
  leading-5
  ml-2
  text-gray-700
  text-sm
`

function Radio({
  checked,
  disabled,
  hasError,
  inputId,
  label,
  onChange,
  willShowNotAllowedCursor,
  ...props
}: RadioProps) {
  const { hasQuestionColor } = useFormAppearance()

  return (
    <label className="mb-0 flex items-start justify-start py-[4.5px]">
      <StyledRadio
        $hasError={hasError}
        $willShowNotAllowedCursor={willShowNotAllowedCursor}
        checked={checked}
        disabled={disabled}
        id={inputId}
        onChange={onChange}
        type="radio"
        {...props}
      />
      {label ? (
        <StyledLabel className={cn(hasQuestionColor && 'question-text')}>
          {label}
        </StyledLabel>
      ) : null}
    </label>
  )
}

export default Radio
